import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_EMISSION_FACTORS } from "../domain";

import { emissionFactorsApi } from "@api/services";
import { ACTION_GET_EMISSION_FACTORS, roleGuard } from "@api";

export const ACTION_DUPLICATE_EMISSION_FACTOR = "DUPLICATE_EMISSION_FACTOR";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const duplicateEmissionFactor = async (emissionFactorId: string): Promise<void> => {
  await emissionFactorsApi.emissionFactorsControllerDuplicateEmissionFactor(
    emissionFactorId,
  );
};

export const useDuplicateEmissionFactor = (
  user: UserProfileDto | null,
): {
  duplicateEmissionFactor: UseMutateFunction<void, unknown, string, unknown>;
  duplicateEmissionFactorEnabled: boolean;
  isSuccessDuplicateEmissionFactor: boolean;
  isPendingDuplicateEmissionFactor: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_EMISSION_FACTORS, ACTION_DUPLICATE_EMISSION_FACTOR],
    mutationFn: enabled ? duplicateEmissionFactor : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_EMISSION_FACTORS, ACTION_GET_EMISSION_FACTORS],
      });
    },
  });

  return {
    duplicateEmissionFactor: mutate,
    duplicateEmissionFactorEnabled: enabled,
    isSuccessDuplicateEmissionFactor: isSuccess,
    isPendingDuplicateEmissionFactor: isPending,
  };
};
